<template>
    <Card :bordered="false" class="border-radius-0" :key="data.useForm.modelRef?.id">
        <CardBorder :title="$t('views.section.licenseDetail')">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">

                <TemplateBuilder :rowProp="data.rowProp"
                                 :useForm="data.useForm"
                                 :fields="data.fields"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
            <!-- force render tab because need validate all tab -->
            <!-- eslint-disable-next-line vue/no-mutating-props -->
            <Tabs v-model:activeKey="menuContext.tabKey" type="card" class="mt-3">
                <TabPane key="Vessel" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fishing-boat.svg"></CIcon>
                        {{$t("views.vessel.title")}}
                    </template>
                    <VesselForm
                            :menuContext="menuContext"
                            :viewOnly="viewOnly"
                            :dataProp="data"
                            dataKey="refVesselRequest"
                            :isLoading="isLoading"
                            itemsKey="refVesselRequest"
                    ></VesselForm>
                </TabPane>
                <TabPane key="VesselOwner" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fisher-man.svg"></CIcon>
                        {{$t("views.vesselOwner.title")}}
                    </template>
                    <VesselOwnerList
                            :menuContext="menuContext"
                            :viewOnly="viewOnly"
                            :dataProp="data"
                            :isLoading="isLoading"
                            dataKey="refVesselRequest"
                            itemsKey="vesselOwnerRequests"
                    ></VesselOwnerList>
                </TabPane>
                <TabPane key="FishingTool" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="fishing-tool.svg"></CIcon>
                        {{$t("views.fishingTool.title")}}
                    </template>
                    <FishingToolList
                            :menuContext="menuContext"
                            :viewOnly="true"
                            :dataProp="data"
                            :isLoading="isLoading"
                            itemsKey="fishingToolRequests"
                    ></FishingToolList>
                </TabPane>
           <!--     <TabPane key="Attachment" :forceRender="true">
                    <template v-slot:tab>
                        <CIcon file="folder.svg"></CIcon>
                        {{$t("views.attachment.title")}}
                    </template>
                    <AttachmentForm
                            :menuContext="menuContext"
                            :viewOnly="viewOnly"
                            :dataProp="data"
                            :isLoading="isLoading"
                            group="LicenseRequestAttachment"
                    ></AttachmentForm>
                </TabPane>-->
                <TabPane key="FeeStatement" v-if="data.useForm.modelRef?.feeStatements?.length">
                    <template v-slot:tab>
                        <CIcon file="active.svg"></CIcon>
                        {{ `${$t('views.feeStatement.tabTitle')} (${data.useForm.modelRef?.refPaymentStatus?.value || ''})` }}
                    </template>
                    <FeeStatementRequestForm
                            :menuContext="menuContext"
                            :viewOnly="viewOnly"
                            :dataProp="data"
                            :isLoadingProp="isLoading"
                            itemsKey="feeStatements"
                    ></FeeStatementRequestForm>
                </TabPane>
                <TabPane key="AdminCommand" v-if="have({ menuContext, keys: ['forDofCenter', 'forAuthorized']}) || data.useForm?.modelRef?.createBy == store.state.resource.auth.info.user?.username">
                    <template v-slot:tab>
                        <CIcon file="active.svg"></CIcon>
                        {{$t("views.license.adminCommandDetail")}}
                    </template>
                    <div v-if="![undefined, 'draft'].includes(data.useForm?.modelRef?.refStatus?.key)">
                        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldProposeRevoke"
                                             :skeleton="isLoading"></TemplateBuilder>
                        </Form>
                        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldLicenseRevokeResultStatus"
                                             :skeleton="isLoading"></TemplateBuilder>
                        </Form>
                    </div>
                    <div v-if="(data.useForm?.modelRef?.isCanAppealLicense || data.useForm?.modelRef?.isHaveAppealedLicense) && data.useForm?.modelRef?.refProposeRevokeStatus?.id != null">
                        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldAppealLicense"
                                             :skeleton="isLoading"></TemplateBuilder>
                        </Form>
                    </div>
                </TabPane>
                <TabPane key="LicenseSuspendedHistories" v-if="have({ menuContext, keys: ['forDofCenter', 'forAuthorized']}) || data.useForm?.modelRef?.createBy == store.state.resource.auth.info.user?.username">
                    <template v-slot:tab>
                        <CIcon file="active.svg"></CIcon>
                        {{$t("views.section.licenseSuspendedHistories")}}
                    </template>
                    <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldLicensSuspendedResultStatus"
                                         :skeleton="isLoading"></TemplateBuilder>
                    </Form>
                    <LicenseSuspendedHistoryList
                            :menuContext="menuContext"
                            :viewOnly="viewOnly"
                            :dataProp="data"
                            :isLoadingProp="isLoading"
                            itemsKey="licenseSuspendedHistories"
                    ></LicenseSuspendedHistoryList>
                </TabPane>
                <TabPane key="LicenseControl" v-if="have({ menuContext, keys: ['forDofCenter', 'forAuthorized']})">
                    <template v-slot:tab>
                        <CIcon file="active.svg"></CIcon>
                        {{$t("views.section.licenseControl")}}
                    </template>
                    <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldPrintStatus"
                                         :skeleton="isLoading"></TemplateBuilder>
                        <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fieldLicensAllResultStatus"
                                         :skeleton="isLoading"></TemplateBuilder>
                    </Form>
                </TabPane>
            </Tabs>
        </CardBorder>
        <CardBorder :title="$t('views.license.licenseCondition')">
            <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
                <TemplateBuilder :rowProp="data.rowProp"
                                 :useForm="data.useForm"
                                 :fields="data.fieldLicenseCondtion"
                                 :skeleton="isLoading"></TemplateBuilder>
            </Form>
        </CardBorder>
        <ChangeLogCollapse
            class="mt-2"
            v-if="visibleChangeLog && data.id"
            :id="data.id"
            :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
            :mappings="[...data.fieldLogs]"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import store from "../../../store";
import { state as stateApp } from "../../../app.logic";
import { onCallChangeLog } from "../../../utils/form";
import {
    initForm,
    isLoading,
    onClickModalOk,
    state,
    createFormTitle
} from "./license.logic";

import { createSearchOneCriteria, callChanges } from "../license-request/request/license/request-license.logic"
import { have } from "../../../utils/menu-context";

export default defineComponent({
    components: {
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        Card,
        CardBorder: defineAsyncComponent(() => import("../../../components/card/CardBorder")),
        Tabs,
        TabPane: Tabs.TabPane,
        CIcon: defineAsyncComponent(() => import("../../../components/icon/CIcon")),
        VesselForm: defineAsyncComponent(() => import("../license-request/vessel/VesselForm")),
        VesselOwnerList: defineAsyncComponent(() => import("../license-request/vessel-owner/VesselOwnerList")),
        FishingToolList: defineAsyncComponent(() => import("../license-request/fishing-tool/FishingToolList")),
        // AttachmentForm: defineAsyncComponent(() => import("../license-request/attachment/AttachmentForm")),
        FeeStatementRequestForm: defineAsyncComponent(() => import("../fee-statement/request/RequestForm")),
        LicenseSuspendedHistoryList: defineAsyncComponent(() => import("./license-suspended-history/LicenseSuspendedHistoryList")),
        ChangeLogCollapse: defineAsyncComponent(() => import("../../../components/change-log/ChangeLogCollapse"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "licenses" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callChanges,
            callOnClickModalOk,
            createSearchOneCriteria,
            onCallChangeLog,
            have,
            store
        };
    }
});
</script>
